// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Vp-z","slideIn":"Wp-z"};